export default {
  portfolio: {
    title: 'Proiectele noastre',
    projects: {
      ai_valuation: 'Evaluare imobiliară cu AI',
      price_prediction: 'Prognozarea prețurilor',
      district_analysis: 'Analiza pieței pe cartiere',
      report_automation: 'Automatizarea rapoartelor',
      developer_api_integration: 'Integrarea cu API-ul dezvoltatorilor',
      investment_index: 'Indici de atractivitate investițională'
    }
  }
}
